import { View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { Divider } from "@/components/shared/divider";
import { CaretDown } from "@/components/shared/icons";
import { formatPrice } from "@/lib/helpers/number";
import { useState } from "react";
import { grey } from "@/constants/colors";

export type PaymentDetailProps = {
  baseAmount: string;
  amount: number;
  balance: string;
  appliedVoucher: number;
};

export const PaymentDetail = ({
  baseAmount,
  amount,
  balance,
  appliedVoucher,
}: PaymentDetailProps) => {
  const [openTotal, setOpenTotal] = useState(false);
  const onToggleTotal = () => setOpenTotal((prev) => !prev);
  return (
    <View className="flex flex-col gap-2 rounded-lg bg-white px-6 py-4">
      <Typography variant="label-md">Payment Details</Typography>
      {openTotal && (
        <View className="flex flex-col gap-1">
          <View className="flex flex-row items-center justify-between gap-2">
            <Typography variant="body-sm" color="foreground-default">
              Subtotal
            </Typography>
            <Typography variant="body-sm" color="brand-primary">
              {baseAmount}
            </Typography>
          </View>
          {appliedVoucher > 0 && (
            <View className="flex flex-row items-center justify-between gap-2">
              <Typography variant="body-sm" color="foreground-default">
                Discount Voucher
              </Typography>
              <Typography variant="body-sm" color="brand-primary">
                -{formatPrice(appliedVoucher)}
              </Typography>
            </View>
          )}
          {!!amount && (
            <View className="flex flex-row items-center justify-between gap-2">
              <Typography variant="body-sm" color="foreground-default">
                GST
              </Typography>
              <Typography variant="body-sm" color="brand-primary">
                {formatPrice(amount)}
              </Typography>
            </View>
          )}
        </View>
      )}
      <Divider />
      <View
        onClick={onToggleTotal}
        className="flex cursor-pointer flex-row items-center justify-between gap-2"
      >
        <Typography variant="body-sm" color="foreground-default">
          Total
        </Typography>
        <View className="flex flex-row items-end gap-1">
          <Typography variant="label-sm" color="brand-primary">
            {balance}
          </Typography>
          {!!amount && (
            <Typography
              variant="caption-md"
              color="foreground-intermediate"
              className="mb-1"
            >
              incl. GST
            </Typography>
          )}
          <CaretDown size={12} color={grey[400]} className="mb-1.5" />
        </View>
      </View>
    </View>
  );
};
